export class Country {

    name: string;
    nameInLanguage?: string;
    isoCode: string;
    phoneCountryCode: string;

    constructor(country?: any) {
        if (country) {
            this.name = country.name;
            this.nameInLanguage = country.nameInLanguage;
            this.isoCode = country.isoCode;
            this.phoneCountryCode = country.phoneCountryCode;
        }
    }

}

export class Language {

    key: string;
    name: string;
    nameInLanguage: string;
    country: Country;

    constructor(language?: any) {
        if (language) {
            this.key = language.key;
            this.name = language.name;
            this.nameInLanguage = language.nameInLanguage;
            this.country = language.country;
        }
    }

}

export const countries: Array<Country> = [
    new Country({ name: 'United States', phoneCountryCode: '+1', isoCode: 'US' }),
    new Country({ name: 'Canada', phoneCountryCode: '+1', isoCode: 'CA' }),
    new Country({ name: 'Russia', phoneCountryCode: '+7', isoCode: 'RU' }),
    new Country({ name: 'Egypt', phoneCountryCode: '+20', isoCode: 'EG' }),
    new Country({ name: 'South Africa', phoneCountryCode: '+27', isoCode: 'ZA' }),
    new Country({ name: 'Greece', phoneCountryCode: '+30', isoCode: 'GR' }),
    new Country({ name: 'Netherlands', phoneCountryCode: '+31', isoCode: 'NL' }),
    new Country({ name: 'Belgium', phoneCountryCode: '+32', isoCode: 'BE' }),
    new Country({ name: 'France', phoneCountryCode: '+33', isoCode: 'FR' }),
    new Country({ name: 'Spain', phoneCountryCode: '+34', isoCode: 'ES' }),
    new Country({ name: 'Hungary', phoneCountryCode: '+36', isoCode: 'HU' }),
    new Country({ name: 'Italy', phoneCountryCode: '+39', isoCode: 'IT' }),
    new Country({ name: 'Romania', phoneCountryCode: '+40', isoCode: 'RO' }),
    new Country({ name: 'Switzerland', phoneCountryCode: '+41', isoCode: 'CH' }),
    new Country({ name: 'Austria', phoneCountryCode: '+43', isoCode: 'AT' }),
    new Country({ name: 'United Kingdom', phoneCountryCode: '+44', isoCode: 'GB' }),
    new Country({ name: 'Denmark', phoneCountryCode: '+45', isoCode: 'DK' }),
    new Country({ name: 'Sweden', phoneCountryCode: '+46', isoCode: 'SE' }),
    new Country({ name: 'Norway', phoneCountryCode: '+47', isoCode: 'NO' }),
    new Country({ name: 'Poland', phoneCountryCode: '+48', isoCode: 'PL' }),
    new Country({ name: 'Germany', phoneCountryCode: '+49', isoCode: 'DE' }),
    new Country({ name: 'Peru', phoneCountryCode: '+51', isoCode: 'PE' }),
    new Country({ name: 'Mexico', phoneCountryCode: '+52', isoCode: 'MX' }),
    new Country({ name: 'Cuba', phoneCountryCode: '+53', isoCode: 'CU' }),
    new Country({ name: 'Argentina', phoneCountryCode: '+54', isoCode: 'AR' }),
    new Country({ name: 'Brazil', phoneCountryCode: '+55', isoCode: 'BR' }),
    new Country({ name: 'Chile', phoneCountryCode: '+56', isoCode: 'CL' }),
    new Country({ name: 'Colombia', phoneCountryCode: '+57', isoCode: 'CO' }),
    new Country({ name: 'Venezuela', phoneCountryCode: '+58', isoCode: 'VE' }),
    new Country({ name: 'Malaysia', phoneCountryCode: '+60', isoCode: 'MY' }),
    new Country({ name: 'Australia', phoneCountryCode: '+61', isoCode: 'AU' }),
    new Country({ name: 'Indonesia', phoneCountryCode: '+62', isoCode: 'ID' }),
    new Country({ name: 'Philippines', phoneCountryCode: '+63', isoCode: 'PH' }),
    new Country({ name: 'New Zealand', phoneCountryCode: '+64', isoCode: 'NZ' }),
    new Country({ name: 'Singapore', phoneCountryCode: '+65', isoCode: 'SG' }),
    new Country({ name: 'Thailand', phoneCountryCode: '+66', isoCode: 'TH' }),
    new Country({ name: 'Japan', phoneCountryCode: '+81', isoCode: 'JP' }),
    new Country({ name: 'South Korea', phoneCountryCode: '+82', isoCode: 'KR' }),
    new Country({ name: 'Vietnam', phoneCountryCode: '+84', isoCode: 'VN' }),
    new Country({ name: 'China', phoneCountryCode: '+86', isoCode: 'CN' }),
    new Country({ name: 'Turkey', phoneCountryCode: '+90', isoCode: 'TR' }),
    new Country({ name: 'India', phoneCountryCode: '+91', isoCode: 'IN' }),
    new Country({ name: 'Pakistan', phoneCountryCode: '+92', isoCode: 'PK' }),
    new Country({ name: 'Afghanistan', phoneCountryCode: '+93', isoCode: 'AF' }),
    new Country({ name: 'Sri Lanka', phoneCountryCode: '+94', isoCode: 'LK' }),
    new Country({ name: 'Myanmar', phoneCountryCode: '+95', isoCode: 'MM' }),
    new Country({ name: 'Iran', phoneCountryCode: '+98', isoCode: 'IR' }),
    new Country({ name: 'Morocco', phoneCountryCode: '+212', isoCode: 'MA' }),
    new Country({ name: 'Algeria', phoneCountryCode: '+213', isoCode: 'DZ' }),
    new Country({ name: 'Tunisia', phoneCountryCode: '+216', isoCode: 'TN' }),
    new Country({ name: 'Libya', phoneCountryCode: '+218', isoCode: 'LY' }),
    new Country({ name: 'Gambia', phoneCountryCode: '+220', isoCode: 'GM' }),
    new Country({ name: 'Senegal', phoneCountryCode: '+221', isoCode: 'SN' }),
    new Country({ name: 'Mauritania', phoneCountryCode: '+222', isoCode: 'MR' }),
    new Country({ name: 'Mali', phoneCountryCode: '+223', isoCode: 'ML' }),
    new Country({ name: 'Guinea', phoneCountryCode: '+224', isoCode: 'GN' }),
    new Country({ name: 'Ivory Coast', phoneCountryCode: '+225', isoCode: 'CI' }),
    new Country({ name: 'Burkina Faso', phoneCountryCode: '+226', isoCode: 'BF' }),
    new Country({ name: 'Niger', phoneCountryCode: '+227', isoCode: 'NE' }),
    new Country({ name: 'Togo', phoneCountryCode: '+228', isoCode: 'TG' }),
    new Country({ name: 'Benin', phoneCountryCode: '+229', isoCode: 'BJ' }),
    new Country({ name: 'Mauritius', phoneCountryCode: '+230', isoCode: 'MU' }),
    new Country({ name: 'Liberia', phoneCountryCode: '+231', isoCode: 'LR' }),
    new Country({ name: 'Sierra Leone', phoneCountryCode: '+232', isoCode: 'SL' }),
    new Country({ name: 'Ghana', phoneCountryCode: '+233', isoCode: 'GH' }),
    new Country({ name: 'Nigeria', phoneCountryCode: '+234', isoCode: 'NG' }),
    new Country({ name: 'Chad', phoneCountryCode: '+235', isoCode: 'TD' }),
    new Country({ name: 'Central African Republic', phoneCountryCode: '+236', isoCode: 'CF' }),
    new Country({ name: 'Cameroon', phoneCountryCode: '+237', isoCode: 'CM' }),
    new Country({ name: 'Cape Verde', phoneCountryCode: '+238', isoCode: 'CV' }),
    new Country({ name: 'Sao Tome and Principe', phoneCountryCode: '+239', isoCode: 'ST' }),
    new Country({ name: 'Equatorial Guinea', phoneCountryCode: '+240', isoCode: 'GQ' }),
    new Country({ name: 'Gabon', phoneCountryCode: '+241', isoCode: 'GA' }),
    new Country({ name: 'Republic of the Congo', phoneCountryCode: '+242', isoCode: 'CG' }),
    new Country({ name: 'Democratic Republic of the Congo', phoneCountryCode: '+243', isoCode: 'CD' }),
    new Country({ name: 'Angola', phoneCountryCode: '+244', isoCode: 'AO' }),
    new Country({ name: 'Guinea-Bissau', phoneCountryCode: '+245', isoCode: 'GW' }),
    new Country({ name: 'British Indian Ocean Territory', phoneCountryCode: '+246', isoCode: 'IO' }),
    new Country({ name: 'Seychelles', phoneCountryCode: '+248', isoCode: 'SC' }),
    new Country({ name: 'Sudan', phoneCountryCode: '+249', isoCode: 'SD' }),
    new Country({ name: 'Rwanda', phoneCountryCode: '+250', isoCode: 'RW' }),
    new Country({ name: 'Ethiopia', phoneCountryCode: '+251', isoCode: 'ET' }),
    new Country({ name: 'Somalia', phoneCountryCode: '+252', isoCode: 'SO' }),
    new Country({ name: 'Djibouti', phoneCountryCode: '+253', isoCode: 'DJ' }),
    new Country({ name: 'Kenya', phoneCountryCode: '+254', isoCode: 'KE' }),
    new Country({ name: 'Tanzania', phoneCountryCode: '+255', isoCode: 'TZ' }),
    new Country({ name: 'Uganda', phoneCountryCode: '+256', isoCode: 'UG' }),
    new Country({ name: 'Burundi', phoneCountryCode: '+257', isoCode: 'BI' }),
    new Country({ name: 'Mozambique', phoneCountryCode: '+258', isoCode: 'MZ' }),
    new Country({ name: 'Zambia', phoneCountryCode: '+260', isoCode: 'ZM' }),
    new Country({ name: 'Madagascar', phoneCountryCode: '+261', isoCode: 'MG' }),
    new Country({ name: 'Reunion', phoneCountryCode: '+262', isoCode: 'RE' }),
    new Country({ name: 'Zimbabwe', phoneCountryCode: '+263', isoCode: 'ZW' }),
    new Country({ name: 'Namibia', phoneCountryCode: '+264', isoCode: 'NA' }),
    new Country({ name: 'Malawi', phoneCountryCode: '+265', isoCode: 'MW' }),
    new Country({ name: 'Lesotho', phoneCountryCode: '+266', isoCode: 'LS' }),
    new Country({ name: 'Botswana', phoneCountryCode: '+267', isoCode: 'BW' }),
    new Country({ name: 'Eswatini', phoneCountryCode: '+268', isoCode: 'SZ' }),
    new Country({ name: 'Comoros', phoneCountryCode: '+269', isoCode: 'KM' }),
    new Country({ name: 'Saint Helena', phoneCountryCode: '+290', isoCode: 'SH' }),
    new Country({ name: 'Eritrea', phoneCountryCode: '+291', isoCode: 'ER' }),
    new Country({ name: 'Aruba', phoneCountryCode: '+297', isoCode: 'AW' }),
    new Country({ name: 'Faroe Islands', phoneCountryCode: '+298', isoCode: 'FO' }),
    new Country({ name: 'Greenland', phoneCountryCode: '+299', isoCode: 'GL' }),
    new Country({ name: 'Gibraltar', phoneCountryCode: '+350', isoCode: 'GI' }),
    new Country({ name: 'Portugal', phoneCountryCode: '+351', isoCode: 'PT' }),
    new Country({ name: 'Luxembourg', phoneCountryCode: '+352', isoCode: 'LU' }),
    new Country({ name: 'Ireland', phoneCountryCode: '+353', isoCode: 'IE' }),
    new Country({ name: 'Iceland', phoneCountryCode: '+354', isoCode: 'IS' }),
    new Country({ name: 'Albania', phoneCountryCode: '+355', isoCode: 'AL' }),
    new Country({ name: 'Malta', phoneCountryCode: '+356', isoCode: 'MT' }),
    new Country({ name: 'Cyprus', phoneCountryCode: '+357', isoCode: 'CY' }),
    new Country({ name: 'Finland', phoneCountryCode: '+358', isoCode: 'FI' }),
    new Country({ name: 'Bulgaria', phoneCountryCode: '+359', isoCode: 'BG' }),
    new Country({ name: 'Lithuania', phoneCountryCode: '+370', isoCode: 'LT' }),
    new Country({ name: 'Latvia', phoneCountryCode: '+371', isoCode: 'LV' }),
    new Country({ name: 'Estonia', phoneCountryCode: '+372', isoCode: 'EE' }),
    new Country({ name: 'Moldova', phoneCountryCode: '+373', isoCode: 'MD' }),
    new Country({ name: 'Armenia', phoneCountryCode: '+374', isoCode: 'AM' }),
    new Country({ name: 'Belarus', phoneCountryCode: '+375', isoCode: 'BY' }),
    new Country({ name: 'Andorra', phoneCountryCode: '+376', isoCode: 'AD' }),
    new Country({ name: 'Monaco', phoneCountryCode: '+377', isoCode: 'MC' }),
    new Country({ name: 'San Marino', phoneCountryCode: '+378', isoCode: 'SM' }),
    new Country({ name: 'Ukraine', phoneCountryCode: '+380', isoCode: 'UA' }),
    new Country({ name: 'Serbia', phoneCountryCode: '+381', isoCode: 'RS' }),
    new Country({ name: 'Montenegro', phoneCountryCode: '+382', isoCode: 'ME' }),
    new Country({ name: 'Croatia', phoneCountryCode: '+385', isoCode: 'HR' }),
    new Country({ name: 'Slovenia', phoneCountryCode: '+386', isoCode: 'SI' }),
    new Country({ name: 'Bosnia and Herzegovina', phoneCountryCode: '+387', isoCode: 'BA' }),
    new Country({ name: 'North Macedonia', phoneCountryCode: '+389', isoCode: 'MK' }),
    new Country({ name: 'Czech Republic', phoneCountryCode: '+420', isoCode: 'CZ' }),
    new Country({ name: 'Slovakia', phoneCountryCode: '+421', isoCode: 'SK' }),
    new Country({ name: 'Liechtenstein', phoneCountryCode: '+423', isoCode: 'LI' }),
    new Country({ name: 'Falkland Islands', phoneCountryCode: '+500', isoCode: 'FK' }),
    new Country({ name: 'Belize', phoneCountryCode: '+501', isoCode: 'BZ' }),
    new Country({ name: 'Guatemala', phoneCountryCode: '+502', isoCode: 'GT' }),
    new Country({ name: 'El Salvador', phoneCountryCode: '+503', isoCode: 'SV' }),
    new Country({ name: 'Honduras', phoneCountryCode: '+504', isoCode: 'HN' }),
    new Country({ name: 'Nicaragua', phoneCountryCode: '+505', isoCode: 'NI' }),
    new Country({ name: 'Costa Rica', phoneCountryCode: '+506', isoCode: 'CR' }),
    new Country({ name: 'Panama', phoneCountryCode: '+507', isoCode: 'PA' }),
    new Country({ name: 'Saint Pierre and Miquelon', phoneCountryCode: '+508', isoCode: 'PM' }),
    new Country({ name: 'Haiti', phoneCountryCode: '+509', isoCode: 'HT' }),
    new Country({ name: 'Guadeloupe', phoneCountryCode: '+590', isoCode: 'GP' }),
    new Country({ name: 'Bolivia', phoneCountryCode: '+591', isoCode: 'BO' }),
    new Country({ name: 'Guyana', phoneCountryCode: '+592', isoCode: 'GY' }),
    new Country({ name: 'Ecuador', phoneCountryCode: '+593', isoCode: 'EC' }),
    new Country({ name: 'French Guiana', phoneCountryCode: '+594', isoCode: 'GF' }),
    new Country({ name: 'Paraguay', phoneCountryCode: '+595', isoCode: 'PY' }),
    new Country({ name: 'Martinique', phoneCountryCode: '+596', isoCode: 'MQ' }),
    new Country({ name: 'Suriname', phoneCountryCode: '+597', isoCode: 'SR' }),
    new Country({ name: 'Uruguay', phoneCountryCode: '+598', isoCode: 'UY' }),
    new Country({ name: 'Curaçao', phoneCountryCode: '+599', isoCode: 'CW' }),
    new Country({ name: 'Timor-Leste', phoneCountryCode: '+670', isoCode: 'TL' }),
    new Country({ name: 'Antarctica', phoneCountryCode: '+672', isoCode: 'AQ' }),
    new Country({ name: 'Brunei', phoneCountryCode: '+673', isoCode: 'BN' }),
    new Country({ name: 'Nauru', phoneCountryCode: '+674', isoCode: 'NR' }),
    new Country({ name: 'Papua New Guinea', phoneCountryCode: '+675', isoCode: 'PG' }),
    new Country({ name: 'Tonga', phoneCountryCode: '+676', isoCode: 'TO' }),
    new Country({ name: 'Solomon Islands', phoneCountryCode: '+677', isoCode: 'SB' }),
    new Country({ name: 'Vanuatu', phoneCountryCode: '+678', isoCode: 'VU' }),
    new Country({ name: 'Fiji', phoneCountryCode: '+679', isoCode: 'FJ' }),
    new Country({ name: 'Palau', phoneCountryCode: '+680', isoCode: 'PW' }),
    new Country({ name: 'Wallis and Futuna', phoneCountryCode: '+681', isoCode: 'WF' }),
    new Country({ name: 'Cook Islands', phoneCountryCode: '+682', isoCode: 'CK' }),
    new Country({ name: 'Niue', phoneCountryCode: '+683', isoCode: 'NU' }),
    new Country({ name: 'Samoa', phoneCountryCode: '+685', isoCode: 'WS' }),
    new Country({ name: 'Kiribati', phoneCountryCode: '+686', isoCode: 'KI' }),
    new Country({ name: 'New Caledonia', phoneCountryCode: '+687', isoCode: 'NC' }),
    new Country({ name: 'Tuvalu', phoneCountryCode: '+688', isoCode: 'TV' }),
    new Country({ name: 'French Polynesia', phoneCountryCode: '+689', isoCode: 'PF' }),
    new Country({ name: 'Tokelau', phoneCountryCode: '+690', isoCode: 'TK' }),
    new Country({ name: 'Federated States of Micronesia', phoneCountryCode: '+691', isoCode: 'FM' }),
    new Country({ name: 'Marshall Islands', phoneCountryCode: '+692', isoCode: 'MH' }),
    new Country({ name: 'North Korea', phoneCountryCode: '+850', isoCode: 'KP' }),
    new Country({ name: 'Hong Kong', phoneCountryCode: '+852', isoCode: 'HK' }),
    new Country({ name: 'Macau', phoneCountryCode: '+853', isoCode: 'MO' }),
    new Country({ name: 'Cambodia', phoneCountryCode: '+855', isoCode: 'KH' }),
    new Country({ name: 'Laos', phoneCountryCode: '+856', isoCode: 'LA' }),
    new Country({ name: 'Bangladesh', phoneCountryCode: '+880', isoCode: 'BD' }),
    new Country({ name: 'Taiwan', phoneCountryCode: '+886', isoCode: 'TW' }),
    new Country({ name: 'Maldives', phoneCountryCode: '+960', isoCode: 'MV' }),
    new Country({ name: 'Lebanon', phoneCountryCode: '+961', isoCode: 'LB' }),
    new Country({ name: 'Jordan', phoneCountryCode: '+962', isoCode: 'JO' }),
    new Country({ name: 'Syria', phoneCountryCode: '+963', isoCode: 'SY' }),
    new Country({ name: 'Iraq', phoneCountryCode: '+964', isoCode: 'IQ' }),
    new Country({ name: 'Kuwait', phoneCountryCode: '+965', isoCode: 'KW' }),
    new Country({ name: 'Saudi Arabia', phoneCountryCode: '+966', isoCode: 'SA' }),
    new Country({ name: 'Yemen', phoneCountryCode: '+967', isoCode: 'YE' }),
    new Country({ name: 'Oman', phoneCountryCode: '+968', isoCode: 'OM' }),
    new Country({ name: 'Palestine', phoneCountryCode: '+970', isoCode: 'PS' }),
    new Country({ name: 'United Arab Emirates', phoneCountryCode: '+971', isoCode: 'AE' }),
    new Country({ name: 'Israel', phoneCountryCode: '+972', isoCode: 'IL' }),
    new Country({ name: 'Bahrain', phoneCountryCode: '+973', isoCode: 'BH' }),
    new Country({ name: 'Qatar', phoneCountryCode: '+974', isoCode: 'QA' }),
    new Country({ name: 'Bhutan', phoneCountryCode: '+975', isoCode: 'BT' }),
    new Country({ name: 'Mongolia', phoneCountryCode: '+976', isoCode: 'MN' }),
    new Country({ name: 'Nepal', phoneCountryCode: '+977', isoCode: 'NP' }),
    new Country({ name: 'Tajikistan', phoneCountryCode: '+992', isoCode: 'TJ' }),
    new Country({ name: 'Turkmenistan', phoneCountryCode: '+993', isoCode: 'TM' }),
    new Country({ name: 'Azerbaijan', phoneCountryCode: '+994', isoCode: 'AZ' }),
    new Country({ name: 'Georgia', phoneCountryCode: '+995', isoCode: 'GE' }),
    new Country({ name: 'Kyrgyzstan', phoneCountryCode: '+996', isoCode: 'KG' }),
    new Country({ name: 'Uzbekistan', phoneCountryCode: '+998', isoCode: 'UZ' }),
];

export const languages: Array<Language> = [
    new Language({ key: 'bg', name: 'Bulgarian', nameInLanguage: 'български', country: countries.filter(c => c.isoCode === 'BG') }),
    new Language({ key: 'cs', name: 'Czech', nameInLanguage: 'český', country: countries.filter(c => c.isoCode === 'CS') }),
    new Language({ key: 'de', name: 'German', nameInLanguage: 'Deutsch', country: countries.filter(c => c.isoCode === 'DE') }),
    new Language({ key: 'en', name: 'English', nameInLanguage: 'English', country: countries.filter(c => c.isoCode === 'EN') }),
    new Language({ key: 'es', name: 'Spanish', nameInLanguage: 'Español', country: countries.filter(c => c.isoCode === 'ES') }),
    new Language({ key: 'fr', name: 'French', nameInLanguage: 'Francais', country: countries.filter(c => c.isoCode === 'FR') }),
    new Language({ key: 'it', name: 'Italian', nameInLanguage: 'Italiano', country: countries.filter(c => c.isoCode === 'IT') }),
    new Language({ key: 'lt', name: 'Lithuanian', nameInLanguage: 'Lietuvis', country: countries.filter(c => c.isoCode === 'LT') }),
    new Language({ key: 'hu', name: 'Hungarian', nameInLanguage: 'Magyar', country: countries.filter(c => c.isoCode === 'HU') }),
    new Language({ key: 'pl', name: 'Polish', nameInLanguage: 'Polski', country: countries.filter(c => c.isoCode === 'PL') }),
    new Language({ key: 'ro', name: 'Romanian', nameInLanguage: 'Română', country: countries.filter(c => c.isoCode === 'RO') }),
    new Language({ key: 'ru', name: 'Russian', nameInLanguage: 'Rусский', country: countries.filter(c => c.isoCode === 'RU') }),
    new Language({ key: 'sk', name: 'Slovak', nameInLanguage: 'Slovenský', country: countries.filter(c => c.isoCode === 'SK') }),
    new Language({ key: 'tr', name: 'Turkish', nameInLanguage: 'Türk', country: countries.filter(c => c.isoCode === 'TR') }),
    new Language({ key: 'el', name: 'Greek', nameInLanguage: 'Ελληνικά', country: countries.filter(c => c.isoCode === 'EL') }),
    new Language({ key: 'da', name: 'Dansk', nameInLanguage: 'Dansk', country: countries.filter(c => c.isoCode === 'DA') }),
    new Language({ key: 'nl', name: 'Dutch', nameInLanguage: 'Nederlands', country: countries.filter(c => c.isoCode === 'NL') }),
    new Language({ key: 'sr', name: 'Serbian', nameInLanguage: 'Serbia', country: countries.filter(c => c.isoCode === 'RS') }),
    new Language({ key: 'hi', name: 'Hindi', nameInLanguage: 'India', country: countries.filter(c => c.isoCode === 'IN') }),
    new Language({ key: 'ar', name: 'Arabic', nameInLanguage: 'Syria', country: countries.filter(c => c.isoCode === 'SY') })
];
